
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Box, Typography, Chip } from "@mui/material"

import moment from "moment"

import { InfoField } from "../components/InfoField"

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle"

import { AmparoProps } from "../interfaces/recepcion/AmparoInterface"

interface Props {
    amparo?:            AmparoProps;
    openDialog:         boolean;
    handleCloseDialog:  () => void;
}

export const DialogAmparo = ({ amparo, openDialog, handleCloseDialog }: Props) => {

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>
                Información del amparo
            </DialogTitle>

            <DialogContent sx={{ ...DialogContentStyle, pt: 3 }}>

                <Grid container spacing={3}>

                    {
                        amparo?.numeroAmparo
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de auxiliar de amparo"
                                    value={ amparo?.numeroAmparo }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.numeroAmparoOrigen
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de amparo de origen"
                                    value={ amparo?.numeroAmparoOrigen }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.fecha
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Fecha"
                                    value={ moment( new Date( amparo?.fecha ) ).format( 'DD-MM-YYYY' ) }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.tipoAmparo
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Tipo de amparo"
                                    value={ amparo?.tipoAmparo }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.autoridadAmparo
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Autoridad del amparo"
                                    value={ amparo?.autoridadAmparo }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.numeroExpediente
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de expediente"
                                    value={ amparo?.numeroExpediente }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.juez
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juez"
                                    value={ amparo?.juez }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.secretario
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a)"
                                    value={ amparo?.secretario }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        amparo?.juzgadoOrigen
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juzgado de origen"
                                    value={ amparo?.juzgadoOrigen }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        ( amparo?.partes && amparo.partes.length !== 0 )
                        &&
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700, mb: 1 }}
                                >
                                    Parte(s):
                                </Typography>

                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {
                                        amparo.partes.map( ({ persona, tipoParte }, index) => (

                                            <Box
                                                key={ index }
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Typography component='div' variant='h6' fontWeight='bold' fontSize={ 16 }>
                                                    { persona }
                                                </Typography>

                                                <Chip
                                                    label={ tipoParte }
                                                    size='small'
                                                    sx={{
                                                        ml: 2,
                                                        fontSize: 11,
                                                        borderRadius: '99px',
                                                        backgroundColor: 'action.hover',
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                    }}
                                                />

                                            </Box>

                                        ))
                                    }
                                </Box>

                            </Grid>
                    }

                    {
                        amparo?.digitalizacion
                        &&
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Digitalización:
                                </Typography>

                                <iframe
                                    title='iframe-documento'
                                    style={{ width: '100%', height: 500, borderRadius: 8 }}
                                    src={ amparo?.digitalizacion ?? '' }
                                />

                            </Grid>
                    }

                </Grid>

            </DialogContent>

            <DialogActions sx={{ ...DialogActionsStyle }}>
                <Button color="secondary" onClick={ handleCloseDialog }>Cerrar</Button>
            </DialogActions>

        </Dialog>
    )
}
